import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.e51_1 = 'Accept';
        this.f51_1 = 'Accept-Charset';
        this.g51_1 = 'Accept-Encoding';
        this.h51_1 = 'Accept-Language';
        this.i51_1 = 'Accept-Ranges';
        this.j51_1 = 'Age';
        this.k51_1 = 'Allow';
        this.l51_1 = 'ALPN';
        this.m51_1 = 'Authentication-Info';
        this.n51_1 = 'Authorization';
        this.o51_1 = 'Cache-Control';
        this.p51_1 = 'Connection';
        this.q51_1 = 'Content-Disposition';
        this.r51_1 = 'Content-Encoding';
        this.s51_1 = 'Content-Language';
        this.t51_1 = 'Content-Length';
        this.u51_1 = 'Content-Location';
        this.v51_1 = 'Content-Range';
        this.w51_1 = 'Content-Type';
        this.x51_1 = 'Cookie';
        this.y51_1 = 'DASL';
        this.z51_1 = 'Date';
        this.a52_1 = 'DAV';
        this.b52_1 = 'Depth';
        this.c52_1 = 'Destination';
        this.d52_1 = 'ETag';
        this.e52_1 = 'Expect';
        this.f52_1 = 'Expires';
        this.g52_1 = 'From';
        this.h52_1 = 'Forwarded';
        this.i52_1 = 'Host';
        this.j52_1 = 'HTTP2-Settings';
        this.k52_1 = 'If';
        this.l52_1 = 'If-Match';
        this.m52_1 = 'If-Modified-Since';
        this.n52_1 = 'If-None-Match';
        this.o52_1 = 'If-Range';
        this.p52_1 = 'If-Schedule-Tag-Match';
        this.q52_1 = 'If-Unmodified-Since';
        this.r52_1 = 'Last-Modified';
        this.s52_1 = 'Location';
        this.t52_1 = 'Lock-Token';
        this.u52_1 = 'Link';
        this.v52_1 = 'Max-Forwards';
        this.w52_1 = 'MIME-Version';
        this.x52_1 = 'Ordering-Type';
        this.y52_1 = 'Origin';
        this.z52_1 = 'Overwrite';
        this.a53_1 = 'Position';
        this.b53_1 = 'Pragma';
        this.c53_1 = 'Prefer';
        this.d53_1 = 'Preference-Applied';
        this.e53_1 = 'Proxy-Authenticate';
        this.f53_1 = 'Proxy-Authentication-Info';
        this.g53_1 = 'Proxy-Authorization';
        this.h53_1 = 'Public-Key-Pins';
        this.i53_1 = 'Public-Key-Pins-Report-Only';
        this.j53_1 = 'Range';
        this.k53_1 = 'Referer';
        this.l53_1 = 'Retry-After';
        this.m53_1 = 'Schedule-Reply';
        this.n53_1 = 'Schedule-Tag';
        this.o53_1 = 'Sec-WebSocket-Accept';
        this.p53_1 = 'Sec-WebSocket-Extensions';
        this.q53_1 = 'Sec-WebSocket-Key';
        this.r53_1 = 'Sec-WebSocket-Protocol';
        this.s53_1 = 'Sec-WebSocket-Version';
        this.t53_1 = 'Server';
        this.u53_1 = 'Set-Cookie';
        this.v53_1 = 'SLUG';
        this.w53_1 = 'Strict-Transport-Security';
        this.x53_1 = 'TE';
        this.y53_1 = 'Timeout';
        this.z53_1 = 'Trailer';
        this.a54_1 = 'Transfer-Encoding';
        this.b54_1 = 'Upgrade';
        this.c54_1 = 'User-Agent';
        this.d54_1 = 'Vary';
        this.e54_1 = 'Via';
        this.f54_1 = 'Warning';
        this.g54_1 = 'WWW-Authenticate';
        this.h54_1 = 'Access-Control-Allow-Origin';
        this.i54_1 = 'Access-Control-Allow-Methods';
        this.j54_1 = 'Access-Control-Allow-Credentials';
        this.k54_1 = 'Access-Control-Allow-Headers';
        this.l54_1 = 'Access-Control-Request-Method';
        this.m54_1 = 'Access-Control-Request-Headers';
        this.n54_1 = 'Access-Control-Expose-Headers';
        this.o54_1 = 'Access-Control-Max-Age';
        this.p54_1 = 'X-Http-Method-Override';
        this.q54_1 = 'X-Forwarded-Host';
        this.r54_1 = 'X-Forwarded-Server';
        this.s54_1 = 'X-Forwarded-Proto';
        this.t54_1 = 'X-Forwarded-For';
        this.u54_1 = 'X-Forwarded-Port';
        this.v54_1 = 'X-Request-ID';
        this.w54_1 = 'X-Correlation-ID';
        this.x54_1 = 'X-Total-Count';
        this.y54_1 = 'Last-Event-ID';
        this.z54_1 = 'TDM-Reservation';
        this.a55_1 = 'TDM-Policy';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b55_1 = ['Transfer-Encoding', 'Upgrade'];
        this.c55_1 = asList(this.b55_1);
      }
      d55(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().o55(name, _unary__edvuaz);
          }
        }
      }
      e55(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().v55(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static a56(header) {
        var $this = this.n2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.z55_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static o55(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.n55_1);
        $this.l55_1 = headerName;
        $this.m55_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static v55(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.u55_1);
        $this.s55_1 = headerValue;
        $this.t55_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance2ik2fiom4sc0n,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
